import { useUpdateEffect } from 'react-use';

/**
 * Hook to update title on re-renders
 * @param {String} title string to set document title to
 * @param {*} dependencies when to update
 */
export default function useUpdateTitle(title = '', dependencies = []) {
  useUpdateEffect(() => {
    if (document.title !== title) document.title = title;
  }, [...dependencies]);
}
